/**
 * Javascript specific to displaying tooltips and popovers
 * Popovers: https://getbootstrap.com/docs/4.0/components/popovers/
 * ToolTips: https://getbootstrap.com/docs/4.0/components/tooltips/
 */

(function (window, document, $) {
	'use strict';

	// General use of Tooltips
	$('[data-toggle="tooltip"]').tooltip({
		trigger: 'click',
		html: true,
		offset: '5,10'
	});

	// Only allow one tooltip open at a time — close others before opening a new one
	$(document).on('click', '[data-toggle="tooltip"]', function () {
		$('[data-toggle="tooltip"]').not(this).tooltip('hide');
	});

	//General use of Popovers
	$('.mstar-popover').popover({
		trigger: 'click',
		html: true,
		offset: '5,10'
	}).on('shown.bs.popover hidden.bs.popover', function (event) {
		$(this).attr('aria-expanded', event.type === 'shown');
	});

	// Close when clicked outside of tooltip/popover
	$(document).on('click', function (event) {
		var $target = $(event.target);
		if (!$target.closest('.tooltip').length && !$target.closest('[data-toggle="tooltip"]').length) {
			$('[data-toggle="tooltip"]').tooltip('hide');
		}
		if (!$target.closest('.popover').length && !$target.closest('[data-toggle="popover"]').length) {
			$('.popover').popover('hide');
		}
	});
	$(document).on('keydown', function (event) {
		if (event.key === 'Escape') {
			var $trigger = $('.mstar-popover[aria-describedby="' + $(event.target).closest('.popover').attr('id') + '"]');
			$('[data-toggle="tooltip"]').tooltip('hide');
			$('.mstar-popover').popover('hide');
			$trigger.trigger('focus');
		}
	});

	// Close button for Popovers.
	$(document).on("click", ".popover .close", function (event) {
		event.preventDefault();
		var $trigger = $('.mstar-popover[aria-describedby="' + $(this).closest('.popover').attr('id') + '"]');
		$(this).parents(".popover").popover('hide');
		$trigger.trigger('focus');
	});

})(window, document, jQuery);